import { render, staticRenderFns } from "./MapLoader.vue?vue&type=template&id=4994f208&scoped=true"
import script from "./MapLoader.vue?vue&type=script&lang=js"
export * from "./MapLoader.vue?vue&type=script&lang=js"
import style0 from "./MapLoader.vue?vue&type=style&index=0&id=4994f208&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4994f208",
  null
  
)

export default component.exports